<template>
  <v-navigation-drawer
    v-if="loggedIn"
    rail-width="42"
    permanent
    :rail="!expandNavigationDrawer"
  >
    <v-list v-model:opened="openedMenus" open-strategy="multiple">
      <NavigationGroup
        :navigation-items="navigationDrawerConfig"
        :expand-navigation-drawer="expandNavigationDrawer"
      />
    </v-list>
    <template #append>
      <NavigationGroup
        v-if="expandNavigationDrawer"
        class="bottom-navigation-group"
        :navigation-items="bottomNavigationDrawerConfig"
        :expand-navigation-drawer="expandNavigationDrawer"
      />

      <!-- absolute so it is layered above ('floats') the navigation items -->
      <v-fab
        id="app-navigation-toggle"
        icon
        size="small"
        absolute
        location="right bottom"
        variant="plain"
        class="navigation-toggle-fab"
        @click="expandNavigationDrawer = !expandNavigationDrawer"
      >
        <v-icon>{{
          expandNavigationDrawer
            ? 'mdi-chevron-double-left'
            : 'mdi-chevron-double-right'
        }}</v-icon>
      </v-fab>
    </template>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { authenticationStore } from '@/store/pinia/AuthenticationStore';
import {
  navigationDrawerConfig,
  defaultOpenedMenus,
  bottomNavigationDrawerConfig
} from '@/navigationDrawer/navigationDrawer';
import { defineComponent } from 'vue';
import { onPremises } from '@/shared/utils';

const OPEN_NAV_GROUPS = 'opened_navigation_groups';

export default defineComponent({
  name: 'NavigationDrawer',
  data() {
    return {
      onPremises,
      expandNavigationDrawer: true,
      bottomNavigationDrawerConfig,
      showDialog: false,
      navigationDrawerConfig,
      openedMenus: [] as string[]
    };
  },
  computed: {
    ...mapState(authenticationStore, ['loggedIn']),
    navDrawerConfig() {
      return navigationDrawerConfig;
    }
  },
  watch: {
    openedMenus(val) {
      localStorage.setItem(OPEN_NAV_GROUPS, JSON.stringify(val));
    }
  },
  beforeMount() {
    const storedNavigationState = localStorage.getItem(OPEN_NAV_GROUPS);
    if (storedNavigationState) {
      this.openedMenus = JSON.parse(storedNavigationState) as string[];
    } else {
      localStorage.setItem(OPEN_NAV_GROUPS, JSON.stringify(defaultOpenedMenus));
      this.openedMenus = defaultOpenedMenus;
    }
  },

  methods: {
    goToPrivacyPolicy() {
      void this.$router.push({ name: 'data-processing-policy' });
    },
    goToOnPremisesTable() {
      void this.$router.push({ name: 'on-premises-versions' });
    }
  }
});
</script>
<style lang="scss" scoped>
a {
  display: inline-block;
}
a.label {
  text-decoration: none;
}
.navigation-toggle-fab {
  z-index: 1;
}
.bottom-navigation-group {
  margin-bottom: 6px;
}
</style>
